import { useContext } from "react";
import { isStaging } from "common/utils/tools";
import { useGetAccountApiKeysQuery } from "../../../../generated/graphql";
import { spacing } from "../../../../stitches.config";
import { AuthContext } from "../../../Authorization/AuthContext";
import { Box } from "../../../Common/__styles__/Layout";
import { Button } from "../../../Common/Buttons/Button";
import Divider from "../../../Common/Divider";
import Table from "../../../Common/Tables/Table";
import { Body, Title } from "../../../Common/Typography";
import { Header, Section } from "../../__styles__/Content";
import { useAddAPIKeyModal } from "./AddAPIKeyModal";
import { useColumns } from "./columns";

const APIKeys = () => {
  const { account } = useContext(AuthContext);

  const { data, loading, refetch } = useGetAccountApiKeysQuery({
    variables: { accountId: account!.id },
  });

  const apiKeys = data?.account?.apiKeys ?? [];
  const existingNames = apiKeys.map(k => k.name);

  const [showAddModal] = useAddAPIKeyModal({ existingNames, refetch });
  const columns = useColumns({ existingNames, refetch });

  return (
    <Box>
      <Header>
        <Title size="small" type="semiBold">
          API Keys
        </Title>
        <Button
          variant="outline"
          onPress={showAddModal}
          size="small"
          iconStart="plus"
          title="Add API Key"
        />
      </Header>
      <Divider />
      <Section
        style={{
          display: "flex",
          flexDirection: "column",
          gap: spacing.m.value,
        }}
      >
        <Body size="default" type="regular" color="contentSecondary">
          API key secrets are only shown once at creation. If you've lost access
          to a key, please talk to engineering.{" "}
          {isStaging() ?
            "Note! Since this is the staging environment, any API key you create here will be deleted over the weekend. Please contact engineering if you need to keep a key."
          : ""}
        </Body>
        <Table
          currentData={apiKeys}
          columns={columns}
          loadingDetails={{
            loading,
            loadingText: "Loading API keys",
            noDataText: "No API keys found",
          }}
          tableStyleDetails={{
            hasFlushedSides: true,
          }}
          excludePaginationNav
        />
      </Section>
    </Box>
  );
};

export default APIKeys;
